export const MINI_DIAGNOSTIC_URL = "https://metmov.com/diagnostic";
// Primary destination for readers who finish a post. metmov.com/operating-spine
// already carries the scoping-call button. UTM tags make "views arriving from
// anjanipandey.com" countable, which is the charter metric for rank 1.
export const OPERATING_SPINE_URL =
  "https://metmov.com/operating-spine?utm_source=anjanipandey&utm_medium=post&utm_campaign=operating-spine";
export const FIT_CALL_URL = "https://cal.com/anjanipandey/ai-diagnostic";
export const BUILD_SPRINT_URL = "https://cal.com/anjanipandey/build-sprint-kickoff";
export const CARE_URL = "https://cal.com/anjanipandey/care-check-in";
export const WHATSAPP_URL = "https://wa.me/919666480007";
export const CONTACT_EMAIL = "contact@anjanipandey.com";
export const LINKEDIN_URL = "https://www.linkedin.com/in/anjanispandey/";
export const METMOV_URL = "https://metmov.com/";
